import * as React from 'react'
import { TouchableOpacity, Text, View } from 'react-native'
import styled from '@theme/styled-components'
import theme from '@theme/Theme'

import Icon from '@components/icon/Icons'

interface Props {
  label: string
  onClick: () => void
  disabled?: boolean
}

const Select = ({ label, onClick, disabled }: Props) => {
  return (
    <Container activeOpacity={0.9} onPress={onClick} disabled={disabled}>
      <Label>{label}</Label>
      <IconContainer>
        <Icon name="arrow-left" size={20} color={theme.colors.primary} />
      </IconContainer>
    </Container>
  )
}

export default Select

const Container = styled(TouchableOpacity)`
  flex-direction: row;
  align-items: center;
  padding: 16px;
  background-color: ${(props) => props.theme.colors.background};
`

const Label = styled(Text)`
  ${(props) => props.theme.fonts.Body};
  flex: 1;
`

const IconContainer = styled(View)`
  margin-left: 16px;
  transform: rotate(180deg);
`
